import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import VCalendar from 'v-calendar'
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueApexCharts from "vue-apexcharts";
Vue.component("apex-chart", VueApexCharts);
import FunctionalCalendar from "vue-functional-calendar/dist/FunctionalCalendar.umd.min.js";

Vue.prototype.$online = Vue.observable({ status: navigator.onLine });

window.addEventListener("online", () => (Vue.prototype.$online.status = true));
window.addEventListener("offline", () => (Vue.prototype.$online.status = false));

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(VCalendar, {
  componentPrefix: 'vc' // use <vc-calendar> in templates
})
Vue.use(FunctionalCalendar, {
  isDatePicker: true,
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
